import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function LoginPage({ setLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [touched, setTouched] = useState(false);
  const navigate = useNavigate();

  const isEmailValid = email.includes('@') && email.includes('.');
  const showError = touched && (!email || !isEmailValid);
  const API_BASE = process.env.REACT_APP_API_URL;

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
  
      if (!res.ok) throw new Error('Login failed');
  
      // ✅ Логін успішний — запускаємо перевірку доменів
      const checkRes = await fetch(`${API_BASE}/api/domains/check-all`, {
        method: 'POST',
      });
  
      if (!checkRes.ok) throw new Error('Domain check failed');
  
      const data = await checkRes.json();
      console.log('Домени перевірено:', data);
  
      // ✅ Після перевірки — оновлюємо статус і переходимо в адмінку
      setLoggedIn(true);
      navigate('/admin');
    } catch (err) {
      alert(err.message || 'Login or domain check failed');
    }
  };
  

  return (
    <div className="d-flex align-items-center justify-content-center bg-light" style={{ minHeight: '100vh' }}>
      <div className="card shadow p-4" style={{ maxWidth: 400, width: '100%' }}>
        <form onSubmit={handleLogin}>
          <div className="text-center mb-4">
            <span className="material-icons" style={{ fontSize: 48, color: '#6f42c1' }}>dashboard</span>
            <h3 className="mt-2 fw-bold">Get Started<br />with your Dashboard</h3>
            <p className="text-muted">Sign in to your account</p>
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              className={`form-control ${showError ? 'is-invalid' : ''}`}
              id="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={() => setTouched(true)}
            />
            {touched && !email && (
              <div className="invalid-feedback">This field is required.</div>
            )}
            {touched && email && !isEmailValid && (
              <div className="invalid-feedback">Please enter a valid email address.</div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Credentials"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="remember" />
              <label className="form-check-label" htmlFor="remember">Remember me</label>
            </div>
            <button type="submit" className="btn btn-primary px-4">Sign in</button>
          </div>
        </form>
      </div>
    </div>
  );
}
